import { TransferStep } from "../class/transferDetails";

const transferStepProgress: Record<Partial<TransferStep>, number> = {
  // Connect old account
  STEP_OLD_ACCOUNT_SPONSOR_NAME: 10,
  STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT: 20,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT: 20,
  STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED: 20,
  STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS: 20,
  STEP_OLD_ACCOUNT_PROVIDER_SEARCH: 20,
  STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN: 20,
  STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT: 40,
  STEP_OLD_ACCOUNT_CONFIRM: 0,
  // FOR ALL SECOND ACCOUNTs == 40
  STEP_OLD_ACCOUNT_COMPLETED_HOME: 40,

  // Destination account
  STEP_DESTINATION_FLASH_LOADING: 45,
  STEP_DESTINATION_OPTIONS: 45,

  STEP_DESTINATION_OPTIONS_TYPE: 45,
  STEP_DESTINATION_CONNECT_IRA: 50,
  STEP_DESTINATION_CONNECT_IRA_TYPE: 50,
  STEP_DESTINATION_OPEN_AND_CONNECT_IRA: 50,
  STEP_DESTINATION_CONNECT_ES: 50,
  STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT: 55,
  STEP_DESTINATION_CONNECT_ES_DETAILS: 55,

  STEP_DESTINATION_HELP: 50,
  STEP_DESTINATION_HELP_RESULT: 50,
  STEP_DESTINATION_HELP_1: 50,
  STEP_DESTINATION_HELP_2: 50,
  STEP_DESTINATION_HELP_3: 50,
  STEP_DESTINATION_HELP_4: 50,
  STEP_DESTINATION_HELP_5: 50,
  STEP_DESTINATION_HELP_6A: 50,
  STEP_DESTINATION_HELP_6B: 50,
  STEP_DESTINATION_HELP_6C: 50,
  STEP_DESTINATION_HELP_RESULT_LOADING: 50,

  STEP_DESTINATION_IRA_METHODOLOGY_SCREEN: 55,
  STEP_DESTINATION_METHODOLOGY_SCREEN: 50,
  STEP_DESTINATION_CHOICES: 45,

  STEP_DESTINATION_EXPLORE_IRA: 55,
  STEP_DESTINATION_EXPLORE_IRA_1: 55,
  STEP_DESTINATION_EXPLORE_IRA_2: 55,
  STEP_DESTINATION_EXPLORE_IRA_3: 55,
  STEP_DESTINATION_EXPLORE_IRA_LOADING: 55,
  STEP_DESTINATION_EXPLORE_IRA_RESULT: 55,
  STEP_DESTINATION_EXPLORE_IRA_OPTIONS: 55,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY: 55,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT: 55,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD: 55,
  STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI: 55,

  STEP_DESTINATION_ACCOUNT: 65,

  STEP_CONFIRM_TRANSFER_DETAILS: 65,
  STEP_PERSONAL_INFO: 70, // Both in and out
  STEP_MARTIAL_INFO: 75, // Both in and out
  STEP_MAILING_ADDRESS: 80, // Both in and out
  STEP_INITIATE_TRANSFER: 90, // Both in and out

  // No Progress bar at all
  STEP_CONSENT: 0,
  STEP_TRANSFER_INFO: 0,
  STEP_POST_TRANSFER: 0, // Both in and out
  STEP_IRA_OPEN_FORM: 0,
  STEP_SCHEDULE_PHONE_CALL: 0, // Both in and out
  STEP_SCHEDULE_PHONE_CALL_NO_LOADING: 0,
  STEP_IRA_EXIT_SCREEN: 0, // Both in and out
  STEP_OPEN_IRA: 0, // Both in and out
  STEP_SCHEDULE_PHONE_CALL_CONFIRMATION: 0,
  STEP_ANNUITY_CONTACT: 0,
  STEP_IDENTITY_VERIFICATION: 0,
  STEP_IDENTITY_VERIFICATION_PERSONA: 0,
  STEP_SPOUSE_NOTARY: 0,
  STEP_TRANSFER_TASKS: 0,
  STEP_FAILED_ID_VERIFICATION: 0,
  STEP_SCHEDULE_PHONE_CALL_LOADING: 0,
};

const getTransferProgress = (step: TransferStep): number => {
  const index = transferStepProgress[step];
  const stepTotal = 100;

  if (!index) {
    return 0;
  } else {
    return index / stepTotal;
  }
};

export default getTransferProgress;
